import SearchIcon from "../assets/svg/SearchIcon.svg";
import Emptyfile1 from "../assets/svg/Emptyfile1.svg";
import TransferIcon1 from "../assets/svg/TranseferIcon1.svg";
import AssignEquipmentToVan from "./Modals/AssignEquipmentToVan";
import { useEffect, useState } from "react";
import EquipmentsVanCard from "./Cards/EquipmentsVanCard";
import axios from "axios";
import { VEHICLE_ASSIGNS } from "../URLs/Apis";
import "../pages/Vehicles/Vehicles.css";
import { useSelector } from "react-redux";
import TransferEquipmentModal from "./Modals/TransferEquipmentModal";
import { useParams } from "react-router";
import { Move } from "lucide-react";
import { Add, Delete, MoveUp, Search } from "@mui/icons-material";
import DeleteModal from "./Modals/DeleteModal";
import { toast } from "react-toastify";
import EquipmentImg from "../assets/svg/defultImage.svg";
import { newImageUrl } from "../pages/Manufacturers/ManufactureProfile";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import transferImg from "../assets/svg/transfer 1.svg"

const Equipment = ({getVehicleById}) => {
  const { user } = useSelector((state) => state.auth);
  const TOKEN = "Bearer " + user?.token;
  const [selectVanModal, setSelectVanModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(false);
  const [equipmentId, setEquipmentId] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [vehicleEquipment, setVehicleEquipment] = useState([]);
  const [checkEquipment, setCheckEquipment] = useState([]);
  const [isSelectedVan, setIsSelectedVan] = useState(false);
  const [isRevoked, setIsRevoked] = useState(false);

  const {id : vanId} = useParams();
    const [showDelete, setShowDelete] = useState(false)
  const handleDeleteShow =()=>{
    setShowDelete(true);
  }
  const handleDeleteClose =()=>{
    setShowDelete(false);
    setIsRevoked(false)
    setCheckEquipment([])
  }
  const revokeEquipmentFromVan = async () => {
    

    try {
      const response = await axios.post(`
       ${VEHICLE_ASSIGNS}/${vanId}/equipments/bulk-revoke`,
        {equipment_ids: checkEquipment},
        { headers: { Authorization: TOKEN } }
      );
      console.log(response);
      toast.success(response.data.data.message);
      handleDeleteClose()
      getVehicleEquipment()
      setSelectedEquipment(false)
      setIsRevoked(false)
      setCheckEquipment([])
      getVehicleById()
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.errors.message);
       error.response.data?.errors?.data?.successful?.forEach((success) => {
        toast.success(success.message)})
    }
  };
  const handleTransfereEquipmentModalShow = (id) => {
    setSelectVanModal(true);
    setEquipmentId(id)
  };

  const handleTransferEquipmentModalClose = () => {
    setSelectVanModal(false);
    
 
  };
  const getVehicleEquipment = async () => {
    try {
      const response = await axios.get(
        `${VEHICLE_ASSIGNS}/${vanId}/equipments/equipment-overview`,
        {
          headers: { Authorization: TOKEN },
        }
      );
    
      setVehicleEquipment(response.data.data?.overview?.assigned_equipments)
    } catch (error) {
      console.log(error);
    }
  };
  const handleEquipmentCard = (checked, equipment) => {
   if(checked){
    
    setCheckEquipment((prev)=> [...prev, equipment.id])
   }
   
  };
 
   const handleRevokeEquipment = ()=>{
    
    if(checkEquipment.length > 0){ 
      setIsRevoked(true)
      handleDeleteShow()
       
    }else{
    setSelectedEquipment(true);
    }
  }
  useEffect(() => {
    getVehicleEquipment();
    
  }, []);
  return (
    <>
       <DeleteModal showDelete={showDelete} handleDeleteClose={handleDeleteClose}textMessage={"Are you sure you want to delete this equipment ? Confirm to proceed or cancel to keep them."} deleteFunction={revokeEquipmentFromVan} />
      <AssignEquipmentToVan
        show={show}
        handleClose={handleClose}
        getVehicleEquipment={getVehicleEquipment}
        getVehicleById={getVehicleById}
      />
      <TransferEquipmentModal
        setSelectVanModal={setSelectVanModal}
        selectVanModal={selectVanModal}
        getVehicleEquipment={getVehicleEquipment}
        handleTransferEquipmentModalClose={handleTransferEquipmentModalClose}
        equipmentId={equipmentId}
        getVehicleById={getVehicleById}
      />
      <div className="col-md-12 min-vh-100">
        <div className="">
          <div
            className=" p-3 my-3 col-md-12 rounded-2 "
            style={{ border: "2px solid #EAEAEA " }}
          >
            <div className="card-body p-2 sm:p-1">
       
   <div className="d-flex align-items-center justify-content-between custom-card-sm ">
              <div
                  className="input-group flex-nowrap  justify-content-end align-items-center rounded-2 w-25 "
                >
                  <input
                    type="text"
                    className={
                      "form-control  bg-transparent position-relative rounded "
                    }
                    placeholder={"Search"}
                    aria-label="Username"
                    aria-describedby="addon-wrapping"
                  />
                   <div className="position-absolute mx-2">
                    <Search/>
                   </div>
                  
                </div>
               
                 <div className="d-flex align-items-center gap-3 button-responsive ">
                   <button onClick={handleRevokeEquipment} className="btn btn-light px-2  "> 
                    <RemoveCircleOutlineOutlinedIcon sx={{marginInline:"3px" , color:"#A80101"}}/>
                    Remove
                    </button>
                   <button onClick={handleShow} className="btn btn-light"> 
                    <Add sx={{marginInline:"3px" }}/>
                    Add Equipment</button>
                </div>

              </div>
          <div className="">
                {vehicleEquipment?.length > 0 ?    
                 <div className=" my-5 row  ">

                  {vehicleEquipment?.map((res)=>
                  {
                    
return(
     <div style={{maxHeight:"300px",overflow:"none"}} className="col-12 col-xl-4 col-md-6 position-relative my-3 ">
                             <div className="position-absolute display-checkboxes">
                             {selectedEquipment && (
                              <input
                                type="checkbox"
                                onChange={(e) => handleEquipmentCard(e.target.checked , res)}
                              />
                            )}
                        </div>
                      <div className="rounded-2 px-3 py-2 bg-light  w-100">
                        <div className="d-flex justify-content-between align-items-center my-1  custom-card-sm gap-2">
                          <div className="d-flex justify-content-center align-items-center custom-card-sm">
                            <h6 className="bg-dark rounded-5 text-white text-center p-2 mb-0  label-van">
                              Equipment # 
                              {res.id}
                            </h6>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                       <div className="cursor" onClick={() => handleTransfereEquipmentModalShow(res.id)}>
                              <img src={transferImg} alt="" />
                            </div>
                         
                            
                          </div>
                        </div>
                    
                        <div className="d-flex justify-content-center custom-hight-img-card">
                          <img
                            src={EquipmentImg}
                            alt="equipment-img"
                            className="img-fluid w-100"
                          />
                        </div> 
                    
                        <h6 className="fw-bold text-center my-2">
                          {res.name}
                          </h6>
                    
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-van">Service Category</h6>
                          <div className="d-flex align-items-center gap-1">
                            <img
                              className="service-icon"
                              src={
                                res.model?.default_image_url
                                  ? `${res.model?.default_image_url}`
                                  : EquipmentImg
                              
                              }
                              alt="category"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <h6 className="text-black m-0 label-van">
                              {res.model?.category?.name}
                              </h6>
                          </div>
                        </div>
                    
                        
                    
                        <div className="d-flex flex-wrap justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-van">Serial Number</h6>
                          <h6 className="text-black my-1 label-van">
                            {res.internal_serial_number}
                            </h6>
                        </div>
                    
                        <div className="d-flex flex-wrap justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-van">Last Service Date</h6>
                          <h6 className="text-black my-1 label-van">
                            </h6>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-van">Last Maintenance</h6>
                          <h6 className="text-black my-1 label-van">
                             {res.maintenance?.last_maintenance_date? new Date(res.maintenance?.last_maintenance_date).toLocaleDateString():"none" }
                            </h6>
                        </div>
                      </div>
                    </div>
)
                  }
                    
                  )}
                  
                </div>
                :
                              <div className=" d-flex  flex-column  align-items-center justify-content-center vh-100 ">
                  <div className=" text-center ">
                    <div>
                      <img
                        src={Emptyfile1}
                        className="img-fluid "
                        alt="No Equipment"
                      />
                    </div>
                    <div className="lh-lg StaffStyle ">
                      <div>No equipment added yet.</div>
                      <div>Start by adding your first item.</div>
                    </div>
                  </div>
                </div>
                }
          </div>
          
         
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Equipment;
